'use strict';
import Vue from 'vue';
import forEach from 'lodash/forEach';
import io from 'socket.io-client'

export default {
	CONNECT ({ getters, rootGetters, state, commit, dispatch }, local) {
		return new Promise((resolve, reject) => {
			if(rootGetters.devmode) console.debug('A|CONNECT');
			if(getters.socket) {
				console.debug('A|DISCONNECT FIRST FROM SOCKET');
				return;
			}

			if(!rootGetters || !rootGetters.channel || !rootGetters.channel.me || !rootGetters.channel.me.id){
				console.debug('A|U NEED TO LOGIN!');
				return;
			}

			const socket_url = (local ? 'localhost:3000' : 'https://sales-tool-store.linienflug.design/');
			const socket = io(socket_url,{
				transports: ['websocket']
			});

			socket.on('connect', function(){
				commit('ONLINE');

				socket.emit('me', rootGetters.channel.me);

				if(getters.pool.length > 0){
					forEach(getters.pool, (payload, index) => {
						dispatch('SEND_PACKAGE', payload)
						.then(function(){
							commit('REMOVE_FROM_POOL', index);
						});
					})
				}
			});

			socket.on('package', function(payload){
				dispatch('PARSE_PACKAGE', payload)
			});

			socket.on('disconnect', function(){
				dispatch('DISCONNECT');
			});

			commit('SET_SOCKET', socket);

			resolve();
		});
	},

	PARSE_PACKAGE ({ getters, rootGetters, state, commit, dispatch }, payload) {
		if(rootGetters.devmode) console.debug('A|PARSE_PACKAGE', payload);
		return new Promise((resolve, reject) => {
			Vue.set(state.live, payload.name, payload.payload);
		});
	},

	SEND_PACKAGE ({ getters, rootGetters, state, commit, dispatch }, payload) {
		if(rootGetters.devmode) console.debug('A|SEND_PACKAGE', payload);
		return new Promise((resolve, reject) => {
			if(!getters.socket){
				commit('ADD_TO_POOL', payload);
				resolve();
				return;
			}

			getters.socket.emit('package', payload)
		});
	},

	DISCONNECT ({ getters, rootGetters, state, commit, dispatch }, payload) {
		return new Promise((resolve, reject) => {
			console.log('DC', payload);
			commit('OFFLINE');
			commit('UNSET_SOCKET');
		});
	}
};



// WEBPACK FOOTER //
// ./src/store/socket/actions.js